// Mock data for Mr. Coconetto website

export const BRAND = {
  name: 'Mr. Coconetto',
  tagline: 'Simply Original',
  logo: 'https://customer-assets-39nsmqrw.emergentagent.net/job_a6cd0a87-081c-4bc9-846e-12b89d12507b/artifacts/deooxfs5_623830492_1285462923637157_9196147907962626499_n.jpg',
  phone: '+91-8700331212',
  phoneRaw: '918700331212',
  email: 'mrcoconetto@gmail.com',
  heroVideo: 'https://seagreen-wildcat-661243.hostingersite.com/wp-content/uploads/2026/05/0518.mp4',
};

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Celebrities', href: '#celebrities' },
  { label: 'Plans', href: '#plans' },
  { label: 'Cities', href: '#cities' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'FAQs', href: '#faqs' },
];

export const MARQUEE_ITEMS = [
  'ONE COCONUT, ENDLESS MEMORIES',
  'Weddings & Engagements',
  'Haldi Ceremony',
  'Mehndi Night',
  'Birthday Parties',
  'Corporate Events',
  'Pool Parties',
  'Baby Showers',
  'Anniversary',
  'Destination Weddings',
];

export const HERO_FEATURES = [
  { icon: 'Check', text: '1000+ Weddings' },
  { icon: 'Cpu', text: 'AI Engraving' },
  { icon: 'MapPin', text: 'Pan-India Delivery' },
  { icon: 'Star', text: 'A+ Grade Coconuts' },
];

export const PRODUCTS = [
  {
    slug: 'customised-coconuts',
    name: 'Customised Coconuts',
    tagline: 'A+ tender coconuts, engraved with your story',
    short: 'The signature Mr. Coconetto experience — hand-picked A+ tender coconuts, personalised with your name, monogram or hashtag and delivered chilled to your venue.',
    long: 'Every coconut is inspected daily, chilled and finished by our master engravers. Choose Monogram, Stamped, Carved or AI-Photo finishes. Minimum 100 pieces per event, pan-India delivery across 27+ cities.',
    hero: 'https://customer-assets-jt897jd0.emergentagent.net/job_coconuts-stage/artifacts/i3711u2b_ChatGPT%20Image%20Aug%201%2C%202026%2C%2004_57_54%20PM.png',
    gallery: [
      'https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1519741347686-c1e0aadf4611?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1508219803418-0a2775190a86?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1200&q=80',
    ],
    features: ['A+ grade tender coconuts', 'Custom monogram / hashtag', '4 engraving finishes', 'Chilled venue delivery'],
  },
  {
    slug: 'banta-bro-bottles',
    name: 'Banta Bro Bottles',
    tagline: 'The nostalgic goli-soda, reborn premium',
    short: 'Classic Indian goli-soda bottles personalised with your event branding — ice-cold, retro-fizzy, unforgettable.',
    long: 'Available in Kala Khatta, Jaljeera, Masala Nimbu, Orange and Rose flavours. Every bottle carries your custom label and monogram. Perfect for sangeet, mehndi and open-air events.',
    hero: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1596803244535-925769f389fc?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1554866585-cd94860890b7?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1544145945-f90425340c7e?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1544148103-0773bf10d330?auto=format&fit=crop&w=1200&q=80',
    ],
    features: ['5 signature flavours', 'Custom event label', 'Served ice-cold', 'Retro goli-soda experience'],
  },
  {
    slug: 'custom-stirrers',
    name: 'Custom Stirrers',
    tagline: 'Bespoke swizzle sticks that tell a story',
    short: 'Laser-engraved bar stirrers in acacia, bamboo and stainless — matched to your palette and your hashtag.',
    long: 'Choose from four wood species and three metal finishes. Each stirrer is engraved with your monogram, event date or a personal note and packaged in matching sleeves.',
    hero: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1543007630-9710e4a00a20?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1587578932292-e576dc9a1a97?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=1200&q=80',
    ],
    features: ['4 wood species + 3 metals', 'Laser engraving', 'Matching sleeves', 'Event-ready packaging'],
  },
  {
    slug: 'hot-stamp-branding',
    name: 'Hot Stamp Branding',
    tagline: 'Deep, permanent brand marks on wood & leather',
    short: 'Metal-die hot-stamping for wood, cork, leather and thick paper — an artisanal branding finish.',
    long: 'From menu covers to wooden coasters and leather nametags, our hot-stamp branding delivers a deep tactile impression that photographs beautifully. Ideal for launches, luxury weddings and corporate gifting.',
    hero: 'https://images.unsplash.com/photo-1541354329998-f4d9a9f9297f?auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1541354329998-f4d9a9f9297f?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1481349518771-20055b2a7b24?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1585159812596-fac104f2f069?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1513013024411-a10485fe9ba3?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=1200&q=80',
    ],
    features: ['Custom metal dies', 'Wood / cork / leather', 'Deep tactile impression', 'Corporate gifting ready'],
  },
  {
    slug: 'hip-flasks',
    name: 'Hip Flasks',
    tagline: 'Personalised keepsakes for the wedding party',
    short: 'Stainless steel hip flasks laser-etched with initials, dates and your event artwork — the groom-squad gift that lasts.',
    long: 'Available in matte black, brushed steel and champagne gold, in 4oz / 6oz / 8oz. Each flask is laser-etched to your artwork and packaged in a keepsake box with a matching funnel.',
    hero: 'https://images.unsplash.com/photo-1522204523234-8729aa6e3d5f?auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1522204523234-8729aa6e3d5f?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1580619305218-8423a7ef79b4?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1569529465841-dfecdab7503b?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1568158879083-c42860933ed7?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1544148103-0773bf10d330?auto=format&fit=crop&w=1200&q=80',
    ],
    features: ['3 finishes · 3 sizes', 'Laser-etched artwork', 'Keepsake box + funnel', 'Groom-squad favourite'],
  },
  {
    slug: 'custom-sticks-skewers',
    name: 'Custom Sticks / Skewers',
    tagline: 'Branded picks for canapés and cocktails',
    short: 'Bamboo, acacia and stainless skewers with your logo engraved on the head — small detail, big statement.',
    long: 'Add editorial polish to every plate. Choose from 5 head shapes and 8 finishes, all delivered event-ready. Perfect for tastings, corporate dinners and cocktail hours.',
    hero: 'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1481070555726-e2fe8357725c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1543007630-9710e4a00a20?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1200&q=80',
    ],
    features: ['5 head shapes · 8 finishes', 'Bamboo / acacia / steel', 'Logo engraved head', 'Event-ready packs'],
  },
];

export const EVENT_TYPES = [
  {
    title: 'Wedding',
    subtitle: 'Celebrating Love & Traditions',
    image: 'https://images.unsplash.com/photo-1587271636175-90d58cdad458?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Corporate Event',
    subtitle: 'Fuel Connections, Inspire Success',
    image: 'https://images.unsplash.com/photo-1767065625309-ef27c9440c95?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Sangeet Night',
    subtitle: 'A Night Full of Music & Laughter',
    image: 'https://images.unsplash.com/photo-1670752617062-e1c4087a346d?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
];

export const STATS = [
  { value: '738+', label: 'Weddings & Events' },
  { value: '14,787+', label: 'Happy Customers' },
  { value: '665+', label: 'Pin Codes Covered' },
  { value: '4+', label: 'Years Experience' },
  { value: '25+', label: 'Team Members' },
];

export const SERVICES = [
  {
    tag: 'Wedding',
    title: 'Baraat Swagat',
    image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/service-baraat-800x600.jpg',
  },
  {
    tag: 'Birthday',
    title: 'Make Every Birthday Extra Special',
    image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/service-birthday-800x600.jpg',
  },
  {
    tag: 'Ceremony',
    title: 'Haldi Ceremony',
    image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/service-haldi-800x600.jpg',
  },
  {
    tag: 'Leisure',
    title: 'Pool Party / Beach Party',
    image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/service-pool-800x600.jpg',
  },
  {
    tag: 'Corporate',
    title: 'Corporate Events & Meetings',
    image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/service-corporate-800x600.jpg',
  },
  {
    tag: 'Mehendi',
    title: 'Mehendi Ceremony',
    image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/service-mehendi-800x600.jpg',
  },
];

export const BIG_EVENTS = [
  'IIFA Awards 2025',
  'Miss World 2025 – India',
  'G20 Summit India',
  'Grand Pre-Wedding Galas',
  'Vantara Launch 2025',
  'International Achievement Awards',
];

export const CELEBRITIES = [
  { name: 'Mouni Roy', role: 'Bollywood Actress & TV Star', tag: 'Featured', image: 'https://paleturquoise-dinosaur-453089.hostingersite.com/wp-content/uploads/2026/07/1684829002697.png' },
  { name: 'Esha Deol', role: 'Bollywood Actress', tag: 'Star', image: 'https://images.unsplash.com/photo-1601491641387-035a4ae3c7cb?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Dia Mirza', role: 'Actress & Former Miss Asia Pacific', tag: 'Star', image: 'https://images.unsplash.com/photo-1670752617062-e1c4087a346d?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Sohail Khan', role: 'Bollywood Actor & Producer', tag: '', image: 'https://images.unsplash.com/photo-1767065625309-ef27c9440c95?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Shilpa Shetty', role: 'Bollywood Actress & Entrepreneur', tag: 'Star', image: 'https://images.unsplash.com/photo-1662364368432-ebea02c6e1da?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Ali Quli Mirza', role: 'Singer & Composer', tag: '', image: 'https://images.unsplash.com/photo-1700760933412-d396694e703e?crop=entropy&cs=srgb&fm=jpg&q=85' },
  { name: 'Aman Verma', role: 'Actor & TV Host', tag: '', image: 'https://images.unsplash.com/photo-1638517307486-4c2ae5c45764?crop=entropy&cs=srgb&fm=jpg&q=85' },
];

export const PLANS = [
  {
    name: 'Gold Plan',
    subtitle: 'Basic Starter Plan',
    highlight: false,
    description: 'Perfect for those who want the freshness of personalized coconuts delivered right to their venue.',
    features: [
      'Premium personalized coconuts with customized straws',
      'Opener / punching key for easy opening & serving',
    ],
    note: 'Service staff, table or counter setup, and décor are to be managed by your team.',
    footer: 'Safe and timely delivery of personalized coconut boxes to your city or venue.',
    minimum: 'Minimum 100 Coconuts',
  },
  {
    name: 'Diamond Plan',
    subtitle: 'Full-Service Experience',
    highlight: true,
    badge: 'Most Preferred',
    description: 'Ideal for weddings & events where you want skilled serving staff without worrying about logistics.',
    features: [
      'Personalized coconuts with bespoke customized straws',
      'Well-groomed & highly skilled CocoBoys for serving & counter handling',
    ],
    note: 'Table & counter is provided by your team.',
    footer: 'Transport, stay, food & travel — every detail handled by Mr. Coconetto team.',
    minimum: 'Minimum 100 Coconuts',
  },
  {
    name: 'Platinum Plan',
    subtitle: 'Our Most Loved Choice',
    highlight: false,
    description: 'Crafted for a truly hassle-free, luxury experience — the top choice of wedding planners.',
    features: [
      'Signature Live Coco Cart with designer décor',
      'Personalized coconuts with bespoke customized straws',
      'Well-groomed & highly skilled CocoBoys',
    ],
    note: '',
    footer: 'From setup, serving & counter management to travel & transport — every detail is handled flawlessly.',
    minimum: 'Minimum 100 Coconuts',
  },
];

export const CITIES = [
  'Agra','Ahmedabad','Alibagh','Bangalore','Bhopal','Chandigarh','Chennai','Delhi','Goa','Hyderabad','Indore','Jaipur','Jaisalmer','Jodhpur','Kanpur','Kolkata','Lucknow','Ludhiana','Mumbai','Mussoorie','Nagpur','NCR','Patna','Pune','Surat','Udaipur','Vadodara',
];

export const OCCASIONS = [
  'Anniversary Celebration','Appreciation Ceremony','Award Ceremony','Baby Birth Celebration','Baby Shower Celebration','Birthday Party','Board Meetings','Charity Events','Club Meetings','Cocktail & Mocktail Party','Conferences','Corporate Events','Devotional Events & Udhyapan','Engagement Function','Expos','Fashion Shows','Festival Parties','Get Together Party','Gifting','Golf Club','Grand Opening Ceremony','House Warming','Kitty Party','Networking Events','Office Parties','Pool Party / Beach Party','Premier Film Screening','Promotional Events','Resorts & Hotels','Restaurant, Bar & Pubs','Retirement Party','Reunion Party','Seminars','Society Party','Sports Tournaments','Trade Shows & Exhibitions','Wedding Ceremony','Wedding Favour','Wedding Invitation','Welcome Drink','Welcome Parties','Workshops',
];

export const WHY_CHOOSE = [
  {
    num: '01',
    icon: 'Cpu',
    title: 'AI-Powered Engraving',
    description: 'State-of-the-art AI technology delivers refined, intricate designs on engraved coconuts — from monograms to floral motifs to couple photos.',
    tag: 'Industry First',
  },
  {
    num: '02',
    icon: 'Award',
    title: 'A+ Grade Quality',
    description: 'Every coconut we serve is A+ grade, handpicked for freshness, sweetness and water volume. Delivered chilled for the best tender coconut experience.',
    tag: 'Premium Quality',
  },
  {
    num: '03',
    icon: 'Clock',
    title: '100% On-Time Delivery',
    description: 'Our dedicated logistics team ensures your personalized coconuts reach the venue fresh, chilled and exactly when you need them.',
    tag: 'Guaranteed',
  },
  {
    num: '04',
    icon: 'Palette',
    title: '100+ Design Options',
    description: 'From carved monograms and stamped logos to pull-tab openings and peeled coconuts — 100+ styles to perfectly match your event theme.',
    tag: 'Fully Custom',
  },
  {
    num: '05',
    icon: 'Globe',
    title: 'Pan-India Presence',
    description: 'With 900+ pin codes covered across 27+ cities, we serve weddings and events everywhere — from destination weddings to corporate events.',
    tag: '900+ Pin Codes',
  },
  {
    num: '06',
    icon: 'Trophy',
    title: 'Trusted by 1000+ Events',
    description: 'From national ceremonies to prestigious awards and grand celebrations — Mr. Coconetto is the trusted brand for India\'s biggest events.',
    tag: 'Celebrity Endorsed',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Aditya Raj',
    city: 'Hyderabad',
    text: 'We loved the creative & customized coconut concept. Absolutely refreshing, and the team\'s service was top-notch. Deserves a perfect 10/10 rating!',
  },
  {
    name: 'Aakansha & Avinash',
    city: 'Chandigarh',
    text: 'You made our wedding functions so stylish and memorable with personalized coconuts. Thank you for making our special day unforgettable.',
  },
  {
    name: 'Ajit Singh',
    city: 'Jodhpur',
    text: 'We sent stamped coconut water as a wedding favour to our guests and everyone loved the concept. Beautifully done — hats off to the team!',
  },
  {
    name: 'Bharti Singh',
    city: 'Agra',
    text: 'Great attention to detail and creative approach. They helped set a new trend at our wedding. Thoroughly professional!',
  },
  {
    name: 'Aditya Khandelwal',
    city: 'Udaipur',
    text: 'A refreshing new concept in the beverage industry. Stamped coconuts looked amazing and truly elevated our function.',
  },
  {
    name: 'Priya Mathur',
    city: 'Delhi',
    text: 'Such a catchy and attractive beverage stall for guests — everyone loved the unique concept and top-quality tender coconuts.',
  },
  {
    name: 'Sonali Jain',
    city: 'Jaipur',
    text: 'The presentation of the coconut water drinks and the stall look was fresh, vibrant and stylish. Truly attractive.',
  },
  {
    name: 'Chandni Kothari',
    city: 'Pushkar',
    text: 'Monogram coconuts looked healthy and elegant. Creative presentation with beautiful signs and tags. Keep up the good work!',
  },
];

export const PARTNERS = [
  'Taj Hotels','Oberoi','The Leela Palace','JW Marriott','Fairmont','Ramada','ITC Hotels','Ananta Resort','Hyatt Regency','Radisson Blu','Sheraton','Novotel','Westin','Four Seasons','Hilton','DoubleTree','Trident','Le Méridien','Marriott','Renaissance','Grand Hyatt','Park Hyatt','Sofitel','Pullman','InterContinental','Crowne Plaza','Lemon Tree','Sarovar','Fortune Hotels','The Park','VITS Hotels','Hotel Clarks',
];

export const FAQS = [
  {
    q: 'What is the minimum order for personalized coconuts?',
    a: 'Our minimum order is 100 coconuts per event. This ensures we can maintain the premium A+ grade quality and freshness for every celebration.',
  },
  {
    q: 'How far in advance should we book Mr. Coconetto?',
    a: 'We recommend booking at least 15–20 days in advance for the best planning and design customization. However, we can also accommodate last-minute requests based on availability.',
  },
  {
    q: 'Do you deliver across India?',
    a: 'Yes! We deliver across 27+ cities and 900+ pin codes in India, including all major metros and destination wedding hubs like Udaipur, Goa, Jaisalmer, and Jaipur.',
  },
  {
    q: 'Can we customize the design on the coconut?',
    a: 'Absolutely! We offer 100+ design styles including monograms, logos, couple names, dates, floral motifs, and even AI-engraved couple photos.',
  },
  {
    q: 'What is included in each plan?',
    a: 'The Gold plan includes coconuts and openers. The Diamond plan adds CocoBoys for serving. The Platinum plan is a full-service experience with our signature Live Coco Cart.',
  },
  {
    q: 'Are the coconuts fresh?',
    a: 'Yes, every coconut is A+ grade tender coconut — handpicked for sweetness and water volume, and delivered chilled for the best taste.',
  },
];
